import React from 'react'
import { Head, withRouteData, Redirect } from 'react-static'
import styled from 'styled-components'

import PeopleBio from '../components/pages/people/PeopleBio'
import Sidebar from '../components/common/sidebar/Sidebar'

const Wrapper = styled.div`
	z-index: 1;
	position: relative;
	padding: 0;

	@media screen and (min-width: 801px) and (max-width: 1919px) {
		padding-left: 20em;
	}

	@media screen and (min-width: 1920px) {
		padding-left: 25em;
	}
`

const People = ({ people, match }) => {
	const person = people.filter(x => match.url.includes(x[0]))[0]
	return (
		<Wrapper>
			<Head>
				<title>People</title>
	      <meta name="description" content="Meet the people."/>
			</Head>
			{person &&
				<React.Fragment>
					<Sidebar title="people" data={people} current="People"/>
					<PeopleBio data={person[1]['data']} />
				</React.Fragment>
			}
		</Wrapper>
	)
}

export default withRouteData(People)


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/People.js